module.exports = __webpack_public_path__ + "static/img/pic.0c343f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/join-us/assets/pic.png
// module id = Ij82
// module chunks = 1